import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { clsx } from 'clsx';

import BlogCoverImg from '../assets/blog-cover.webp';

export type ICtaProps = {
	
    title: string;
	subtitle: string;
    compact?: boolean;
};

export const BlogCover = (props: ICtaProps) => {
    
    return (
        <div style={{
            backgroundImage: `url(${BlogCoverImg})`,
            backgroundSize: "cover",
            margin: 0,
            color: "white",
            padding: props.compact ? "40px 0" : "80px 0",
            textAlign: "center",
        }}>
            <span style={{
                display: "block",
                fontFamily: "ShadowsIntoLight",
                fontSize: "3em",
                margin: 0,
                padding: "8px",
                lineHeight: "1.1",
                fontWeight: "bold",
            }}>{ props.title }</span>
            <span style={{
                fontSize: "1.3em",
                margin: 0,
                opacity: 0.8,
            }}>{ props.subtitle }</span>
    
        </div>
	
	);
}
